module.exports = __webpack_public_path__ + "img/fen.f004abad.png";